import React from 'react';
import { Link } from 'react-router-dom';
import PageTemplate from '../components/PageTemplate';

const Engineering = () => {
  return (
    <PageTemplate
      title="Engineering Solutions"
      subtitle="Advanced engineering services for embedded systems, IoT, and industrial applications"
      breadcrumb="Engineering"
    >
      <div className="content-section">
        <div className="content-grid">
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-microchip"></i>
            </div>
            <h4>Embedded Systems</h4>
            <p>Custom embedded software and firmware development for various industries including automotive, aerospace, and medical devices.</p>
            <Link to="/engineering/embedded-systems" className="btn btn-outline">Learn More</Link>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-wifi"></i>
            </div>
            <h4>IoT Development</h4>
            <p>End-to-end IoT solutions from sensor integration to cloud connectivity and data analytics.</p>
            <Link to="/engineering/iot-development" className="btn btn-outline">Explore IoT</Link>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-rocket"></i>
            </div>
            <h4>MVP Development</h4>
            <p>Rapid prototyping and MVP development to validate your ideas and accelerate time-to-market.</p>
            <Link to="/engineering/mvp-development" className="btn btn-outline">Start MVP</Link>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-car"></i>
            </div>
            <h4>Automotive Solutions</h4>
            <p>Advanced automotive software solutions including autonomous systems and connected vehicle technologies.</p>
            <Link to="/engineering/automotive" className="btn btn-outline">View Automotive</Link>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Engineering; 